import { arrayToBase64, decryptWithRsaBlockCipher, } from '@lucidlink/ts-crypto/crypto';
export const remapInvitationResponse = async (response, adminCrypto) => {
    const adminKeys = await adminCrypto.verifyAndGetAdminKeys();
    const linkSecretArray = await decryptWithRsaBlockCipher(response.eInvitationSecretByAdminKey, adminKeys.encryptPair.privateKey);
    return {
        id: response.id,
        linkSecret: arrayToBase64(linkSecretArray),
        isEncrypted: false,
    };
};
